export const useUsers = createQuery('/users')

useUsers.useUpdate = createMutation('PATCH', '/users/:id', (ctx) => {
  useUsers.replaceOne(ctx)
})
